<template>
    <div>
        <div class="banner">
          


            <div class="banner-center">
                <div class="textbox">
                    <div class="banner-text1">互联场地管理系统</div>
                    <div class="banner-text2">助力建设全国统一大市场，优化市场营商环境</div>
            </div>

            <div >
                <img src="../../assets/img/banner2/4-2.png" alt="" class="banner-img">
            </div>
            </div>
          


        </div>
        <!-- 互认具体步骤 -->
        <div class="box1">
            <mytitle title="对接实施具体步骤" style="margin-top: 64px;"></mytitle>



            <div class="stepbox">
                <div class="stepitembg">
                    <div class="overtop"></div>
                    <div class="stepitem">


                        <div class="step-top">
                            <img src="../../assets/img/step/step-top.svg" alt="" style="width: 133px;height: 70px;">





                        </div>
                        <div class="stepindex">1</div>

                        <div class="stepico">
                            <img src="../../assets/img/step/step-ico.svg" alt="" style="width: 32px;height: 35px;">
                        </div>

                        <div class="stepTitle">
                            阅读接入指南
                        </div>

                        <div class="stepText">
                            预览、下载《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》
                        </div>

                        <div style="display: flex;margin-top: 44px;justify-content: space-evenly;padding: 0 10px;">




                            <el-button class="btn2" @click="Previewzn(7)">预览</el-button>
                            <el-button type="primary" class="btn1"
                                @click="downzn(7, '')">下载</el-button>


                        </div>


                    </div>
                </div>

                <div class="stepitembg">
                    <div class="overtop"></div>

                    <div class="stepitem">
                        <div class="step-top">
                            <img src="../../assets/img/step/step-top.svg" alt="" style="width: 133px;height: 70px;">





                        </div>
                        <div class="stepindex">2</div>

                        <div class="stepico">
                            <img src="../../assets/img/step/step-ico.svg" alt="" style="width: 32px;height: 35px;">
                        </div>

                        <div class="stepTitle">
                            远程异地评标 <br>目录服务组件集成对接
                        </div>

                        <div class="stepText" >
                            联系中国招标投标公共服务平台运维实施人员集成对接远程异地评标共享目录服务组件
                        </div>

                        <div style="display: flex;margin-top: 20px;justify-content: space-evenly;padding: 0 10px;">




                            <el-button class="btn2" @click="Previewzn(7)">预览</el-button>
                            <el-button type="primary" class="btn1"
                                @click="downzn(7, '')">下载</el-button>


                        </div>



                    </div>
                </div>

                <div class="stepitembg">
                    <div class="overtop"></div>
                    <contactUs v-show="showContactUs1"></contactUs>

                    <div class="stepitem">
                        <div class="step-top">
                            <img src="../../assets/img/step/step-top.svg" alt="" style="width: 133px;height: 70px;">





                        </div>
                        <div class="stepindex">3</div>

                        <div class="stepico">
                            <img src="../../assets/img/step/step-ico.svg" alt="" style="width: 32px;height: 35px;">
                        </div>

                        <div class="stepTitle">
                            与跨省远程异地目录服务<br>组件共同联调测试
                        </div>

                        <div class="stepText">
                            与跨省远程异地目录服务组件共同联调测试相关接口
                        </div>

                        <div style="display: flex;margin-top: 34px;justify-content: space-evenly;padding: 0 10px;">
                            <el-button class="btn2" style="width: 256px;" @mouseover="showContactUs1 = true" @mouseleave="showContactUs1 = false">联系我们</el-button> 

                        </div>





                    </div>

                </div>

                <div class="stepitembg">
                    <div class="overtop"></div>
                    <div class="stepitem">
                        <div class="step-top">
                            <img src="../../assets/img/step/step-top.svg" alt="" style="width: 133px;height: 70px;">





                        </div>
                        <div class="stepindex">4</div>

                        <div class="stepico">
                            <img src="../../assets/img/step/step-ico.svg" alt="" style="width: 32px;height: 35px;">
                        </div>

                        <div class="stepTitle">
                            公开测试承诺
                        </div>

                        <div class="stepText">
                            与跨省远程异地目录服务组件共同联调测试通过后，通过远程异地评标和评标专家库共享目录服务组件自助管理终端，上传并公开测试承诺书和自主测试报告，自助加入场地管理系统互联目录
                        </div>



                    </div>
                </div>










            </div>






        </div>




        <!-- 互联场地管理系统目录 -->

        <systemCatalog title="互联场地管理系统目录" placeholder="请输入场地管理系统名称搜索"></systemCatalog>


        <!-- 填写信息弹框 -->
        <infoDailog :showRegister.sync="showRegister" :registrationType.sync="registrationType" @confirm="confirm"
            @canDownload="canDownload"></infoDailog>



    </div>


</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted, defineProps, defineEmits } from 'vue'
import systemCatalog from '../../components/systemCatalog'
import { useRoute } from 'vue-router'
const route = useRoute()
import { useRouter } from "vue-router";
const router = useRouter();
import { getOrgCatalog, getTestScripts, endpointDownload, documentPreview, DownloadTestScripts, downloadWithFilePath } from '../../utils/axios/index.js'
import infoDailog from '../infoDailog.vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'


let showContactUs1 = ref(false)
// 预览文档
const Previewzn = (type: any) => {
    // documentPreview({ documentType: type }).then(res => {
    //     window._czc.push(['_trackEvent', '互认CA机构', '预览', 'CA机构接入指南预览'])

    //     window.open(res.data.documentUrl, '_blank');
    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })
    // ElMessage.warning('功能开发中，敬请期待！')
    window._czc.push(['_trackEvent', '场地管理系统', '预览', '场地管理系统接入指南预览'])

    window.open('S03远程异地评标和评标专家库共享技术标准_场地管理系统接入指南_20250605_1600.pdf', '_blank');

}
//跳转视频
const tovideo = () => {
    window.open('https://www.yunpan.com/surl_y9tqAvIvstR', '_blank')
}

// 下载文档
const downzn = (type: any, name: any) => {
    // window._czc.push(['_trackEvent', '互认CA机构', '下载', 'CA机构接入指南下载'])
    // let name2 = ''
    // documentPreview({ documentType: type }).then(res => {
    //     name2 = res.data.documentName


    //     endpointDownload({ documentType: type }).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }


    //     }).catch(res => {

    //     })

    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })


    // ElMessage.warning('功能开发中，敬请期待！')


    window._czc.push(['_trackEvent', '场地管理系统', '下载', '场地管理系统接入指南下载'])


    const a = document.createElement('a')
    a.href = 'S03远程异地评标和评标专家库共享技术标准_场地管理系统接入指南_20250605_1600.pdf'
    a.download = 'S03远程异地评标和评标专家库共享技术标准_场地管理系统接入指南_20250605_1600.pdf'
    a.click()

}

//机构名称搜索参数
let caOrgName = ref('')


//列表
let allapplist = ref([])

//查看更多
let btnmore = ref(true)


// 搜索

const getOrgList = () => {
    getOrgCatalog({ caOrgName: caOrgName.value }).then(res => {
        allapplist.value = res.data

        allapplist.value.map(item => {
            item.ishover = false
        })


        applist.value = allapplist.value



        btnmore.value = false


    }).catch(err => {
    })
}

// 查看更多
const showmore = () => {
    applist.value = allapplist.value
    btnmore.value = false
}

onMounted(() => {
    // getOrgList()

})
import { ElMessage } from 'element-plus'
//打开弹框
const openDialog = () => {
    // showRegister.value = true
    // canDownload()

    window._czc.push(['_trackEvent', '互认CA机构', '下载测试脚本', '下载CA机构测试脚本'])


    DownloadTestScripts({ scriptType: 1 }).then(res => {
        if (res.data.testScriptsFile) {
            showRegister.value = true
        } else {
            ElMessage.warning('功能开发中，敬请期待！')
        }
    })


}
//下载文件
const downloadFile = (fileUrl, fileName) => {
    // 创建一个a标签  
    const a = document.createElement('a');
    a.href = fileUrl; // 设置文件URL  
    a.download = fileName; // 设置下载的文件名  

    // 隐藏a标签（可选）  
    a.style.display = 'none';

    // 将a标签添加到body中（一些浏览器要求这样做才能触发下载）  
    document.body.appendChild(a);

    // 模拟点击  
    a.click();

    // 移除a标签（可选）  
    document.body.removeChild(a);
}



//关闭弹框

const confirm = () => {
    showRegister.value = false

}
//下载文件

const canDownload = () => {
    DownloadTestScripts({ scriptType: 1 }).then(res1 => {
        // showpdf(res1.data.testScriptsFile)

        downloadFile(res1.data.testScriptsFile, res1.data.testScriptsName)


        // const url = new URL(res1.data.testScriptsFile)
        // let path = String(url.pathname)
        // downloadWithFilePath({ contentDisposition: 'attachment', filePath: path }).then(res => {

        //     var blob = new Blob([res])
        //     let fname = res1.data.testScriptsName + '.zip'; //下载文件的名字
        //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //         window.navigator.msSaveOrOpenBlob(blob, fname);
        //     } else {
        //         let objectUrl = URL.createObjectURL(blob);
        //         let link = document.createElement("a");
        //         link.href = objectUrl;
        //         link.setAttribute("download", fname);
        //         document.body.appendChild(link);
        //         link.click();
        //     }

        // }).catch(res => {

        // })

    }).catch(res => {

    })

}
let showRegister = ref(false)
//弹框类型
let registrationType = ref(2)

//跳转交易平台
const tosystemJoin = () => {
    router.push({
        path: '/systemJoin',
        query: {
            bottom: true
        }
    })
}
//跳转互认app
const toApp = () => {
    router.push({
        path: '/appJoin',
        query: {
            bottom: true
        }
    })
}
//查看pdf
const showpdf = (url, type) => {
    if (type == 1) {
        window.open(url, '_blank');
    } else {
        window.open(url, '_self');
    }

}





let applist = ref([])



</script>
<style lang="scss" scoped>
@import "../../assets/css/step.scss";


.banner {
    width: 100%;
    height: 577px;
    position: relative;
    background: url('../../assets/img/banner2/4-1.png') no-repeat center center;
    background-size: cover;

    .banner-center{
        width: 1200px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        top: 116px;
    }
    .textbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
 
    .banner-img{
        // width: 658px;
        height: 413px;
        margin-top: 40px;
        margin-right: -40px;         
    }

    .banner-text1 {
        color: var(--Color-Neutral-neutral-11, #323335);
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 70px;
        text-align: left
    }

    .banner-text2 {
        color: var(--Color-Neutral-neutral-10, #64666B);
        text-align: center;
        
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: left
    }


}

.box1 {
    width: 100%;
    height: 536px;
    padding: 1px 0 0 0;

}




.box2 {
    width: 100%;

    .box2-top {
        width: 100%;
        height: 311px;
        background: url('../../assets/img/banner/search.webp') no-repeat center center;
        background-size: 100% 100%;
        padding: 1px;
        box-sizing: border-box;

        .search {
            width: 600px;
            margin: 0 auto;
            display: flex;
            height: 42px;
            background: #fff;
            align-items: center;
            border-radius: var(--Radius-Border-radius-3, 4px);
            padding: 0 3px 0 10px;
            margin-top: 48px;


        }


    }


    .line {
        width: 80%;
        height: 1px;
        margin: 0 auto;
        background-color: rgb(235, 235, 237);
        margin-top: 10px;
    }








    .appbox {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        border-radius: var(--Radius-Border-radius-3, 4px);
        border: var(--Radius-Border-radius-2, 2px) solid #FFF;
        // background: linear-gradient(0deg, #FFF 0%, #F3F5F8 100%);
        background: #FFF;

        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);
        margin-top: -40px;



        .appcard {

            width: 300px !important;
            height: 176px;
            padding: 42px 114px 0px 114px;
            box-sizing: border-box;
            position: relative;



            .appName {



                color: #16181A;
                text-align: center;
                
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
                // margin-top: -20px;


                // width: 80px;
                overflow: hidden;
                /* 保持文本在一行内 */
                white-space: nowrap;
                /* 文本超出时显示省略号 */
                text-overflow: ellipsis;



            }

            .userbox {
                width: 320px;
                height: 360px;
                position: absolute;
                top: -470px;
                left: 50%;
                transform: translateX(-50%);
                border-radius: var(--Radius-Border-radius-6, 16px);
                box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.08);
                background-color: #fff;
                z-index: 50;
                padding: 40px 36px;

                .appTop {
                    display: flex;
                    text-align: left;

                    .appName2 {
                        color: #020814;
                        /* text-align: center; */
                        
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 32px;
                        letter-spacing: 0.072px;
                        width: 200px;
                        overflow: hidden;
                        /* 保持文本在一行内 */
                        white-space: nowrap;
                        /* 文本超出时显示省略号 */
                        text-overflow: ellipsis;
                        margin-top: 10px;
                    }

                    .appTime {
                        color: #41464F;
                        
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                        margin-top: 5px;
                        text-align: left;
                    }
                }

                .info-title {
                    color: #020814;
                    
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 26px;
                    letter-spacing: 0.054px;
                    text-align: left;
                }

                .info-text {
                    color: var(--Color-Neutral-neutral-10, #64666B);
                    
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 22px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                }

                .boxdown {
                    position: absolute;
                    bottom: -20px;
                    width: 48px;
                    height: 23px;
                    background: url('../../assets/img/bidEvaluationTools/down.png') no-repeat center center;
                    background-size: contain;
                    left: 50%;
                    transform: translateX(-50%);
                }






            }

            .content {
                width: 100%;
                height: 100px;
            }





        }




 

        .appcard2 {
            display: flex;
            width: 300px;
            height: 176px;
            padding: var(--Radius-Border-radius-5, 12px) 24px 24px 24px;
            flex-direction: column;
            align-items: flex-start;
            border-radius: var(--Radius-Border-radius-4, 8px);
            border: var(--Radius-Border-radius-2, 2px) solid var(--Text-Text-4, #F4F4F5);
            background: linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);

            box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.10);
            box-sizing: border-box;

            .appTop {
                display: flex;
                text-align: left;

                .appName2 {
                    color: #020814;
                    text-align: center;
                    
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    width: 200px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: left;
                    margin-top: 10px;

                }

                .appTime {
                    color: #41464F;
                    
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                    text-align: left;
                }
            }

            .info-text {
                color: var(--Color-Neutral-neutral-10, #4E5969);
                
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 18px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                background: linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), var(--Branding-Blue-6, #3461FF);
                padding: 3px 7px;

            }

            .info-text2 {
                color: var(--Color-Neutral-neutral-10, #4E5969);
                
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 22px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;


            }


        }


    }
}

:deep(.el-input__wrapper) {
    box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
    cursor: default;
    border: none !important;

}

.appimg {
    width: 120px;
    height: 120px;
    border-radius: 30px;
    border: 1.875px solid var(--Color-Branding-branding-1, #ECF2FF);
    background: #FFF;
}

.appimg2 {
    width: 20px;
    height: 20px;
}


.appimg3 {
    width: 72px;
    height: 72px;
    background: #FFF;
}

.appimg5 {
    width: 90px;
    height: 90px;
    border-radius: 10px;
    border: 1.875px solid var(--Color-Branding-branding-1, #ECF2FF);
}

.cns-text {
    color: #64666B;
    font-size: 14px;
    font-weight: 400;
    margin-left: 8px;
}

.cns-url {
    width: 60%;
    margin-left: 8px;
    color: #3461FF;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    font-size: 14px;
}

.cns-ico {
    width: 20px;
    height: 20px;
}

.cns-btn {
    color: #FFF;
    border-color: #3461FF;
    height: 40px;
    width: 100%;
    background-color: #3461FF;
    font-size: 14px;
    border: none;
    margin-top: 30px;
}

.btn1 {
    background-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: none;
}

.btn2 {
    color: #3461FF;
    border-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
}

.btn2:hover {
    color: #fff;
    background-color: #3461FF;
    border-color: #3461FF;

}





.searchbtn {
    background-color: #3461FF;
    width: 120px;
    font-size: 14px;
    height: 32px;
    border: none;
}

.paperview-input-text {
    font-size: 14px;
    height: 32px
}

.btnmore {
    color: #606266;
    border-color: #DCDFE6;
    height: 40px;
    width: 170px;
    margin-top: 80px;
    margin-bottom: 200px;
    font-size: 14px;
    border: 1px solid #DCDFE6;
}

.tonext {
    width: 32px;
    height: 60px;

}

.icobox {
    font-size: 20px;
    height: 60px;
    line-height: 60px;
    width: 32px;
    text-align: center;
}

.morebox {
    width: 100%;
    text-align: center;
    height: 190px;
    margin-top: -30px;
}

.point {
    color: #4E5969;
    font-size: 30px;
}

.appcard3 {
    width: 300px !important;
    height: 176px;
    // padding: 25px 100px 0px 100px;
    text-align: center;
    padding-top: 36px;
    box-sizing: border-box;
}

.yyinfo {
    display: flex;
    align-items: center;
    height: 22px;
}

.lxinfo {
    margin-top: 15px;
}

.appimg4 {
    width: 45px;
    height: 45px;
    border-radius: 10px;
    border: 1px solid var(--Color-Branding-branding-1, #ECF2FF);
    background: #FFF;
}

.info-text3 {
    color: var(--Text-neutral-9, #969AA0);
    
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    /* 150% */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}






</style>